import React from 'react';
import { TableHeadersType } from '../../../../../constant/tableHeadersConstants/tableHeadersType';
import { AllUnitsMeasurementListType } from '../../../../../redux/clientSettings/clientSettingTypes';
import {formateDateTime } from '../../../../../utils/commonFunctions';
import UpdatedByAndUpdatedAt from '../../../../commons/CommonUpdatedByAndUpdatedAt';



type AppProps = {
  tableHeaders: TableHeadersType[];
  data: [] | AllUnitsMeasurementListType[];
  handleEditUnitsMeasurmentDetails: (data: AllUnitsMeasurementListType) => void;
  isEditUnitOfMeasurementPresent?:boolean
}

const UnitsMeasurmentListTableData = ({
  tableHeaders,
  data,
  handleEditUnitsMeasurmentDetails,
  isEditUnitOfMeasurementPresent
}: AppProps) => {


  return (
    <>
      {data?.map((dataItem: any) => {
        return <tr>
          {tableHeaders?.length && tableHeaders?.map((item: any) => {
             if (item?.value === "updated_by") {
              return (
                <td style={{width:'180px'}}>
                   <UpdatedByAndUpdatedAt
                    firstName={dataItem?.updated_by?.first_name ? dataItem?.updated_by?.first_name:''}
                    lastName={dataItem?.updated_by?.last_name ? dataItem?.updated_by?.last_name:''}
                    profilePic={dataItem?.updated_by?.profile_pic?.file_url}
                    updatedAt={formateDateTime(dataItem?.updated_at)}
        />
                  
                </td>
              );
            }
            else if (dataItem[item.value]) {
              return <td className='text-start'> {dataItem[item.value]}</td>
            }
            else {
              return <td> --/-- </td>
            }
          })}
          <td style={{ width: '80px', textAlign: 'center' }}>
           {isEditUnitOfMeasurementPresent && <span className="d-inline-block pointer"
              onClick={() => handleEditUnitsMeasurmentDetails?.(dataItem)}
            >
              <div style={{
                color: '#d43',
                fontSize: 20,
              }}><i className="fas fa-pen"></i></div>
            </span>}
          </td>
        </tr>
      })}
    </>
  )
};

export default UnitsMeasurmentListTableData;